module.exports = __webpack_public_path__ + "img/picture2.a9a3af57.jpg";